import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import homeMadeFoodImg from "../../../assets/home_made_food_3.jpeg";

const SLIDES = [
  { value: "Home-Cooked", label: "Meals prepared by verified home chefs" },
  { value: "Fresh Daily", label: "Cooked fresh — never frozen" },
  {
    value: "Careful Delivery",
    label: "Handled with hygiene and temperature care",
  },
];

const BrandCard = () => {
  const [index, setIndex] = useState(0);

  // slide
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % SLIDES.length);
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="d-none d-lg-flex w-100 position-relative flex-column align-items-center justify-content-center overflow-hidden m-4 me-0"
      style={{
        minHeight: "100%",
        padding: "3rem",
        borderRadius: "1.5rem",
        width: "40%",
        height: "50vh",
      }}
    >
      {/* FOOD IMAGE */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${homeMadeFoodImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* DARK GRADIENT */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.3), rgba(0,0,0,0.1))",
        }}
      />

      {/* BRAND TINT */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: "rgba(27, 109, 193, 0.15)",
          mixBlendMode: "color",
        }}
      />
    </div>
  );
};

export default BrandCard;
